import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import DeviceCascader from '@blade-sxp/monitor-center/pages/components/dialog/device-cascader.vue';
import { getConfig, setConfig } from '@blade-sxp/monitor-center/api/index';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    msg;
    idts = '781757999742976';
    loading = true;
    result = true;
    form = {
        linkageDevices: [''],
        currentDeviceAlertDuration: 10,
        linkageDeviceAlertDelayTime: 3,
        linkageDeviceAlertDuration: 8,
        status: 'ENABLE',
        propertyDisplay: 'ENABLE',
        configId: 0,
        selectDeviceId: '',
        // radio: true,
    };
    submitLinkageDevices = [];
    r = /^([1-9]\d*|[0]{1,1})$/;
    // PleaseEnterCurrentDeviceAlertDuration
    // PleaseEnterLinkageDeviceAlertDelayTime
    // PleaseEnterLinkageDeviceAlertDuration
    rules = {
        currentDeviceAlertDuration: [
            { required: true, message: `${this.$t('pleaseEnterCurrentDeviceAlertDuration')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (this.r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 5 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveIntegerOf').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
        linkageDeviceAlertDelayTime: [
            { required: true, message: `${this.$t('pleaseEnterLinkageDeviceAlertDelayTime')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (this.r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 0 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveIntegerOfOne').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
        linkageDeviceAlertDuration: [
            { required: true, message: `${this.$t('pleaseEnterLinkageDeviceAlertDuration')}`, trigger: 'blur' },
            {
                validator: (_, value, callback) => {
                    if (this.r.test(value)) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveInteger').toString()));
                    }
                },
                trigger: 'blur',
            },
            {
                validator: (_, value, callback) => {
                    if (Number(value) >= 5 && Number(value) <= 60) {
                        callback();
                    }
                    else {
                        callback(new Error(this.$t('pleaseEnterPositiveIntegerOf').toString()));
                    }
                },
                trigger: 'blur',
            },
        ],
    };
    cancelDig() {
        this.$emit('update:dialogVisible', false);
        this.$emit('closeMsg', '');
    }
    // isMath(str: string) {
    //   if (!/^\d+$/.test(str)) ;
    // }
    created() { }
    mounted() {
        // console.log('getConfig', this.msg);
        const param = {
            operateIds: [this.msg.id],
        };
        getConfig(param)
            .then((res) => {
            // console.log('数据', res);
            if (res.length) {
                this.form = res[0];
                if (res[0]?.linkageDevices) {
                    this.form.selectDeviceId = res[0]?.linkageDevices[0]?.id;
                }
                // this.form.linkageDevices
                // this.form.linkageDevices=res[0].linkageDevices
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    changeCascader(value) {
        this.form.selectDeviceId = value;
    }
    onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                const param = {
                    currentDeviceAlertDuration: Number(this.form.currentDeviceAlertDuration),
                    deviceId: this.msg.id,
                    linkageDevice: [this.form.selectDeviceId],
                    linkageDeviceAlertDelayTime: Number(this.form.linkageDeviceAlertDelayTime),
                    linkageDeviceAlertDuration: Number(this.form.linkageDeviceAlertDuration),
                    propertyDisplay: this.form.propertyDisplay,
                    resultType: 'ALERT',
                    status: this.form.status,
                    configId: this.form.configId,
                };
                setConfig(param).then((res) => {
                    this.$emit('submit', param);
                    this.cancelDig();
                });
            }
            else {
                return false;
            }
        });
        // console.log('数据', this.form);
    }
};
__decorate([
    Prop({ default: true })
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "msg", void 0);
default_1 = __decorate([
    Component({
        name: 'viedialog',
        components: { DeviceCascader },
        i18n: {
            messages: {
                'en-us': {
                    yes: 'Yes',
                    algorithmLayer: 'Algorithm Layer',
                    deviceLinkageStrategyTitle: 'Device Linkage Strategy',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    settings: 'Settings',
                    taskName: 'Task Name',
                    result: 'Result',
                    alert: 'Alert',
                    propertyDisplay: 'Property Display',
                    linkageDevice: 'Linkage Device',
                    devicePlaceholder: 'Please select the device to be linked',
                    linkageDeviceAlertDelayTime: 'Linkage Device Alert Delay Time',
                    linkageDeviceAlertDelayTimeMsg: 'After the device receives the target warning message, how long is the delay for the linkage device to start the alarm',
                    linkageDeviceAlertDuration: 'Linkage Device Alert Duration',
                    seconds: 'Seconds',
                    currentDeviceAlertDuration: 'Current Device Alert Duration',
                    PleaseEnterCurrentDeviceAlertDuration: 'Please Enter Current DeviceAlert Duration',
                    PleaseEnterLinkageDeviceAlertDelayTime: 'Please Enter Linkage Device Alert Delay Time',
                    PleaseEnterLinkageDeviceAlertDuration: 'Please Enter Linkage Device Alert Duration',
                    pleaseEnterPositiveInteger: 'Please Enter A Positive Integer',
                    pleaseEnterPositiveIntegerOf: 'Please Enter A Positive Integer of 5~60',
                    pleaseEnterPositiveIntegerOfOne: 'Please Enter A Positive Integer of 0~60',
                },
                zh: {
                    no: '否',
                    yes: '是',
                    algorithmLayer: '算法层',
                    deviceLinkageStrategyTitle: '设备联动策略',
                    submit: '提交',
                    cancel: '取消',
                    settings: '设置',
                    taskName: '任务名称',
                    result: '结果',
                    alert: '警报',
                    propertyDisplay: '属性显示',
                    linkageDevice: '联动设备',
                    devicePlaceholder: '请选择要链接的设备',
                    linkageDeviceAlertDelayTime: '联动装置警报延迟时间',
                    linkageDeviceAlertDelayTimeMsg: ' 设备收到目标告警信息后，联动设备延迟多长时间启动告警',
                    pleaseEnterCurrentDeviceAlertDuration: '请输入当前设备警报持续时间',
                    pleaseEnterLinkageDeviceAlertDelayTime: '请输入联动装置警报延迟时间',
                    pleaseEnterLinkageDeviceAlertDuration: '请输入联动装置警报时长',
                    pleaseEnterPositiveInteger: '请输入正整数',
                    pleaseEnterPositiveIntegerOf: '请输入5~60的正整数',
                    pleaseEnterPositiveIntegerOfOne: '请输入0~60的正整数',
                    currentDeviceAlertDuration: '当前设备警报持续时间',
                    linkageDeviceAlertDuration: '联动装置警报时长',
                    seconds: '秒',
                },
            },
        },
    })
], default_1);
export default default_1;
